import { Modal } from '@material-ui/core';
import { colors } from '../../../../../../colorVars';
import { TextButton } from '../../../../../atomic/atomicComponentLibrary/buttons/textButton/TextButton';
import { Body1, Body3 } from '../../../../../atomic/text/Text';
import style from './AllowTemplatesWarningModal.module.css';

type Props = {
  open: boolean;
  handleClose: () => void;
  setAllowTemplates: (value: boolean) => void;
};

const AllowTemplatesWarningModal = ({
  open,
  handleClose,
  setAllowTemplates,
}: Props) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className={style.container}>
        <div className={style.text}>
          <div>
            <Body1 color={colors.red}>Warning</Body1>
          </div>
          <div>
            <Body3 color={colors.lightGrey}>
              Using the template feature of this section should only be used if
            </Body3>
          </div>
          <div>
            <Body3 color={colors.lightGrey}>
              you are very familiar with the contents of your trade plan
              templates.
            </Body3>
          </div>
          <div>
            <Body3 color={colors.lightGrey}>
              You will not be able to see all of your trade plan settings via
              this interface.
            </Body3>
          </div>
          <div style={{marginBottom: '15px'}}>
            <Body3 color={colors.lightGrey}>Use with caution.</Body3>
          </div>
        </div>
        <div className={style.buttons}>
          <TextButton
            minWidth='53px'
            backgroundColor="green"
            fontColor="white"
            size="medium"
            loading={false}
            clickHandler={() => {
              setAllowTemplates(true);
              handleClose();
            }}
          >
            Ok
          </TextButton>
          <TextButton
            minWidth='53px'
            backgroundColor="red"
            fontColor="white"
            size="medium"
            loading={false}
            clickHandler={handleClose}
          >
            Cancel
          </TextButton>
        </div>
      </div>
    </Modal>
  );
};

export default AllowTemplatesWarningModal;
